module.exports = __webpack_public_path__ + "img/higuchi_vue.a150f898.jpg";